import type { FileData, LaunchPadData } from '@mogul/api-client';

import {
  cloudfrontDevBase,
  cloudfrontProdBase,
  isProduction,
  production,
} from '../config';
import type { NftAsset } from './nft-api.hook';

export const getCloudfrontUrl = (storage_key: string) => {
  const base = isProduction ? cloudfrontProdBase : cloudfrontDevBase;
  return `${base}/${storage_key}`;
};

export const useCloudfrontNftAsset = (
  asset: NftAsset | FileData | undefined,
) => {
  if (asset) {
    return {
      cloudfrontUrl: getCloudfrontUrl(asset.storageKey ?? ''),
      mimeType: asset.mimeType,
    };
  } else {
    return { cloudfrontUrl: null, mimeType: '' };
  }
};

export const useCloudfrontLaunchpad = (
  launchpad: LaunchPadData | undefined,
) => {
  const updated = launchpad;

  if (production) {
    //banner
    if (updated?.bottomBanner) {
      updated.bottomBanner = {
        publicUrl: getCloudfrontUrl(updated.bottomBanner.storageKey ?? ''),
        mimeType: updated.bottomBanner.mimeType,
        storageKey: updated.bottomBanner.storageKey,
        id: updated.bottomBanner.id,
        filename: '',
        encoding: null,
        size: '',
        createdBy: null,
        uploadUrl: '',
        isPublic: true,
        createdAt: '',
        updatedAt: '',
      };
    }

    //featured
    if (updated?.nftSamples && updated.nftSamples.length) {
      for (let i = 0; i < updated.nftSamples.length; i++) {
        updated.nftSamples[i] = {
          publicUrl: getCloudfrontUrl(updated.nftSamples[i].storageKey ?? ''),
          mimeType: updated.nftSamples[i].mimeType,
          storageKey: updated.nftSamples[i].storageKey,
          id: updated.nftSamples[i].id,
          filename: '',
          encoding: null,
          size: '',
          createdBy: null,
          uploadUrl: '',
          isPublic: true,
          createdAt: '',
          updatedAt: '',
        };
      }
    }

    //roadmap
    if (updated?.roadmap && updated.roadmap.length) {
      for (const roadmap of updated.roadmap) {
        if (roadmap.image !== null) {
          roadmap.image = {
            publicUrl: getCloudfrontUrl(roadmap.image.storageKey ?? ''),
            mimeType: roadmap.image.mimeType,
            storageKey: roadmap.image.storageKey,
          };
        }
      }
    }

    //featuredVideo
    if (updated?.collection?.featuredVideo) {
      updated.collection.featuredVideo = {
        publicUrl: getCloudfrontUrl(
          updated.collection.featuredVideo.storageKey ?? '',
        ),
        mimeType: updated.collection.featuredVideo.mimeType,
        storageKey: updated.collection.featuredVideo.storageKey,
      };
    }
  }

  return updated;
};
